import {Switch, useRouteMatch} from "react-router-dom";
import {useTranslation} from "react-i18next";

import AllEvents from "./All";
import FavoriteEvents from "./Favorite";
import GuardedRoute from "../../components/Route/GuardedRoute";
import usePageMeta from "../../services/page-meta";

export default function EventsPage() {
    const { t } = useTranslation();
    usePageMeta({
        title: t('conferences.title'),
        description: t('app.description'),
        keywords: t('app.keywords'),
    });

    const { path } = useRouteMatch();

    return (
        <Switch>
            <GuardedRoute
                exact
                path={path}
            >
                <AllEvents />
            </GuardedRoute>
            <GuardedRoute
                exact
                path={`${path}/favorite`}
                authRequired
            >
                <FavoriteEvents />
            </GuardedRoute>
        </Switch>
    );
}
